let branch;

export async function initializeBranch() {
  if (typeof window === "undefined") {
    console.log("Branch SDK can only be initialized in a browser environment.");
    return Promise.reject("Not in browser environment");
  }

  if (!branch) {
    try {
      const modules = await import("branch-sdk");
      branch = modules.default;

      return new Promise((resolve, reject) => {
        branch.init(
          "key_live_da76nsJLGhDYek1vWSUuieecswmlNglG",
          (err, data) => {
            if (err) {
              console.error("Branch initialization failed:", err);
              reject(err);
            } else {
              // console.log("Branch initialized successfully:", data);
              resolve(data);
              // branch.view();
            }
          }
        );
      });
    } catch (error) {
      console.error("Error loading Branch SDK:", error);
      throw error;
    }
  }

  console.log("Branch SDK already initialized.");
  return Promise.resolve(); // Branch is already initialized
}

export function trackEvent(eventName, id) {
  if (!branch) {
    // console.error("trackEvent: Branch SDK is not initialized.");
    return;
  }
  // console.log(`${eventName} event tracked run`);
  const linkData = {
    event: eventName, // Required
    name: eventName,
    campaign: "promo",
    channel: "web",
    feature: "click_tracking",
    stage: "new user",
    serviceId: id,
    $canonical_url: window.location.href,
  };

  branch.logEvent(eventName, linkData, (err, res) => {
    if (err) {
      console.error("Failed to track event:", err);
    } else {
      console.log("Event tracked successfully:", res);
    }
  });
}

export function waitForBranch() {
  return new Promise((resolve) => {
    const checkBranch = () => {
      if (typeof branch !== "undefined") {
        resolve();
      } else {
        setTimeout(checkBranch, 1000);
      }
    };
    checkBranch();
  });
}

// export async function createBranchLink() {
//   if (typeof window === "undefined") {
//     console.error("createBranchLink: Not running in a browser environment.");
//     return;
//   }

//   if (!branch) {
//     console.error("createBranchLink: Branch SDK is not initialized.");
//     return;
//   }

//   const linkData = {
//     campaign: "promo",
//     channel: "web",
//     feature: "click_tracking",
//     stage: "new user",
//   };

//   branch.link(linkData, function (err, link) {
//     if (err) {
//       console.error("Failed to generate Branch Link:", err);
//     } else {
//       console.log("Generated Branch Link:", link);
//     }
//   });
// }
